// assets
import { BugFilled,StarFilled,SlidersFilled  } from "@ant-design/icons";


import { DiseaseIcon,PestIcon,WeedIcon } from "./icons";

// icons
const icons = {
  BugFilled,
  StarFilled,
  SlidersFilled,
  DiseaseIcon,
  PestIcon,
  WeedIcon


};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
  id: "pages",
  title: "Pages",
  type: "group",
  app: 'ipms',
  children: [
    {
      id: "pests",
      title: "Insects",
      type: "item",
      url: "/pest-crops",
      icon: icons.PestIcon,
      breadcrumbs: false,
    },
    {
      id: "disease-crops",
      title: "Diseases",
      type: "item",
      url: "/disease-crops",
      icon: icons.DiseaseIcon,
      breadcrumbs: false,
    },
    {
        id: "weeds",
        title: "Weeds",
        type: "item",
        url: "/weeds",
        icon: icons?.WeedIcon,
        breadcrumbs: false,
      },
  ],
};

export default pages;
